export const fileIconList = [
  {
    type: ["pdf"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/pdf.png",
  },
  {
    type: ["doc", "docx", "wps"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/docx.png",
  },
  {
    type: ["xls", "xlsx"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/xlsx.png",
  },
  {
    type: ["ppt", "pptx"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/pptx.png",
  },
  {
    type: ["zip"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zip.png",
  },
  {
    type: ["rar"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/rar.png",
  },
  {
    type: ["7z"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/7Z.png",
  },
  {
    type: ["mp3"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mp3.png",
  },
  {
    type: ["mp4", "m4a"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mp4.png",
  },
  {
    type: ["png"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/png.png",
  },
  {
    type: ["jpg"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/jpg.png",
  },
  {
    type: ["gif"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/gif.png",
  },
  {
    type: ["svg"],
    url: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/svg.png",
  },
];

const DEFAULT_ICON =
  "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/txt.png";

/**
 * 根据文件名自动匹配对应文件图标
 * @param {string} fileName 完整文件名，例如：合同.pdf、报表.xlsx
 * @returns {string} 图标URL
 */
export function getFileIcon(fileName) {
  if (!fileName || typeof fileName !== "string") {
    return DEFAULT_ICON;
  }

  // 提取文件后缀，转小写，兼容大小写格式
  const ext = fileName.split(".").pop().toLowerCase();
  if (!ext) return DEFAULT_ICON;

  // 匹配对应图标
  const target = fileIconList.find((item) => item.type.includes(ext));
  return target ? target.url : DEFAULT_ICON;
}

export function Filetype(url) {
  //0 视频 1音乐 2pdf  3图片 4 word
  if (url) {
    const type = {
      0: ["mp4"], //视频
      1: ["mp3", "ogg"], //音频
      2: ["pdf", "ofd"], //pdf
      3: ["bmp", "jpg", "png", "gif", "jpeg"], //图片
      4: [
        "doc",
        "docx",
        "docm",
        "dotx",
        "xls",
        "xlsx",
        "xlsm",
        "xltx",
        "xltm",
        "xlsb",
        "xlam",
        "PPt",
        "pptx",
        "pptm",
        "ppsx",
        "ppsm",
      ], //文件
      5: ["m4a"],
      6: ["amr"],
      7: ["zip", "rar", "7Z", "txt"],
    };

    let suffix = url.slice(url.lastIndexOf(".") + 1);
    for (let val in type) {
      if (type[val].indexOf(suffix.toLowerCase()) >= 0) {
        return val.toLowerCase();
      }
    }
  }
}
export function getFilePath(url) {
  if (!url) return "";

  try {
    // URL 对象处理完整 URL
    const pathname = new URL(url).pathname;

    // 去掉开头的 /
    return pathname.replace(/^\/+/, "");
  } catch (e) {
    // 如果传入的本身就是路径
    return String(url).replace(/^\/+/, "");
  }
}
